<script>
import CustomerListDesktopView from "./CustomerListDesktopView.vue";

/**
 * Desktop list layout bridge.
 * Renders CustomerListDesktopView using the parent customer-list instance as
 * context so template bindings and $refs stay on list.vue (provide/inject).
 */
export default {
  name: "CustomerListDesktopBridge",
  inject: ["customerList"],
  render() {
    const customerList = this.customerList;
    const viewOptions = CustomerListDesktopView.options || CustomerListDesktopView;
    const render = viewOptions.render;

    if (!customerList || typeof render !== "function") {
      return null;
    }

    const options = customerList.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(customerList, customerList.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
